// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import { Link } from '@zapier/design-system';

import Logo from 'web-ssr/app/common/components/Logo';
import SocialLinks from 'web-ssr/app/common/components/ContentFooter/SocialLinks';
import Text from 'web-ssr/app/common/components/Text';

// !!! IMPORTANT !!!
//
// The SCSS styles used by this component are no longer accessible. In order to
// modify this component you will need to refactor it to use CSS-in-JS

const bem = bemify('footer');

type Props = {
  isLoggedIn: boolean,
  /**
   * Adjusts the footer to be compatible with 1200px design system layout.
   * This is a temporary fix until the new header is implemented.
   **/
  isDesignSystemFooter: boolean,
};

const Footer = (props: Props) => {
  const { isLoggedIn, isDesignSystemFooter } = props;

  return (
    <footer
      className={bem(
        toModifiers({ 'design-system-footer': isDesignSystemFooter })
      )}
    >
      <nav
        aria-label="Zapier footer links"
        className={bem(
          '__primary-links',
          toModifiers({ 'design-system-footer': isDesignSystemFooter })
        )}
      >
        <Link href={isLoggedIn ? '/app/billing/plans' : '/pricing'} role="link">
          <Text color="grey700" fontWeight={600} type="subtitle700">
            {isLoggedIn ? 'Plans' : 'Pricing'}
          </Text>
        </Link>
        <Link href="/help/" role="link">
          <Text color="grey700" fontWeight={600} type="subtitle700">
            Help
          </Text>
        </Link>
        <Link href="/platform" role="link">
          <Text color="grey700" fontWeight={600} type="subtitle700">
            Developer Platform
          </Text>
        </Link>
        <Link href="/press" role="link">
          <Text color="grey700" fontWeight={600} type="subtitle700">
            Press
          </Text>
        </Link>
        <Link href="/jobs/" role="link">
          <Text color="grey700" fontWeight={600} type="subtitle700">
            Jobs
          </Text>
        </Link>
        <Link href="/companies/" role="link">
          <Text color="grey700" fontWeight={600} type="subtitle700">
            Zapier for Companies
          </Text>
        </Link>
      </nav>

      <div className={bem('__logo')}>
        <Logo className={bem('__wiggle')} />
        <div className={bem('__tagline')}>
          <Text color="grey700" type="altText900">
            makes you happier :)
          </Text>
        </div>
      </div>

      <div className={bem('__social')}>
        <Text color="grey700" fontWeight={600} type="altText900">
          Follow us
        </Text>

        <SocialLinks className={bem('__social-list')} />
      </div>

      <div className={bem('__secondary-links')}>
        <Text color="grey700" type="altText900">
          © {new Date().getFullYear()} Zapier Inc.
        </Text>

        <div className={bem('__link', '--secondary')}>
          <Link href="/terms/" role="link">
            <Text color="grey700" type="altText900">
              Terms
            </Text>
          </Link>
        </div>

        <div className={bem('__link', '--secondary')}>
          <Link href="/privacy/" role="link">
            <Text color="grey700" type="altText900">
              Privacy
            </Text>
          </Link>
        </div>

        <div className={bem('__link', '--secondary')}>
          <Link href="/brand/" role="link">
            <Text color="grey700" type="altText900">
              Brand
            </Text>
          </Link>
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  isDesignSystemFooter: false,
};

export default Footer;
